import { useSelector } from "react-redux";

import { selectCurrentUserId } from "@/redux/selectors/authSelectors";
import type { UUID } from "@/core/types";

export function useCurrentUserId(): undefined | UUID {
  return useSelector(selectCurrentUserId);
}
